function getConfig(name, defaultValue = null) {
  // If inside a docker container, use window.ENV
  if (window.ENV !== undefined) {
    return window.ENV[name] || defaultValue;
  }

  return import.meta.env[name] || defaultValue;
}

export function workspaceSlug() { return window.location.pathname.match(/^\/app\/([a-f0-9]{16})(?:\/|$)/)?.[1] || ""; }
export function getBackendUrl() {
  const base = (getConfig("VITE_BACKEND_URL") || "").replace(/\/$/, "");
  return workspaceSlug() ? base + "/workspaces/" + workspaceSlug() : base;
}

export function getHoursCloseTicketsAuto() {
  return getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO");
}
// Exemplo no config.js
const systemName = "ZapTicket";
